import { PHONENUMBER_FORMAT } from "../../constants";
import { GridColumnConfig } from "../../models/gridCoumnConfig";

export const fastFieldContactColumn: GridColumnConfig[] = [
    {
        title: 'Title',
        field: 'contactsTitle',
        filter: 'text',
        width: '100',
        searchable: true,
    },
    {
        title: 'Contact Name',
        field: 'contactsFullName',
        filter: 'text',
        width: '180',
        searchable: true,
    },
    // {
    //   title: 'Description',
    //   field: 'contactsDescription',
    //   filter: 'text',
    //   searchable: true,
    // },
    {
        title: 'Work Email',
        field: 'contactsWorkEmail',
        filter: 'text',
        searchable: true,
        width: '320',
    },
    {
        title: 'Other Email',
        field: 'contactsSecondaryEmail',
        filter: 'text',
        width: '175',
        searchable: true,
    },
    {
        title: 'Office Phone',
        field: 'contactsOfficePhone',
        filter: 'text',
        width: '175',
        searchable: true,
        formatPattern: PHONENUMBER_FORMAT,
    },
    {
        title: 'Cell Phone',
        field: 'contactsCellPhone',
        filter: 'text',
        width: '175',
        searchable: true,
        formatPattern: PHONENUMBER_FORMAT,
    },
    {
        title: ' Role',
        field: 'contactsRoleName',
        filter: 'text',
        width: '175',
        searchable: true,
    },
    {
        title: 'Send Report',
        field: 'canSendReport',
        filter: 'text',
        width: '175',
        searchable: true,
    },
    {
        title: 'Master Contact',
        field: 'masterContacts',
        filter: 'text',
        width: '175',
        searchable: true,
    },
    {
        title: 'FastField CM',
        field: 'isFastFieldCM',
        filter: 'text',
        width: '175',
        isGroupable:false,
        searchable: false,
        isHideColumnMenu: true
    },
    // {
    //   title: 'Special Instruction',
    //   field: 'specialInstructions',
    //   filter: 'text',
    //   searchable: true,
    // },
    // {
    //   title: 'Status',
    //   field: 'contactsStatus',
    //   filter: 'text',
    //   searchable: true,
    // }
];
